import type { RenderFilter } from "./types";

export const useShouldShowMarketingFilters = (filters: RenderFilter[]) =>
  filters;
